export * from './score-section'
export * from './score.component'
